// @ts-nocheck
import React from 'react';
import {
  ContentCut, Spa, AutoFixHigh, HealthAndSafety, ColorLens,
  SelfImprovement, LocalFlorist, Palette, Flare, WaterDrop,
  FitnessCenter, Pets, Diamond, AutoAwesome, Favorite,
  MedicalServices, InvertColors, CleanHands, ChildCare,
  RadioButtonChecked, EmojiNature, Healing, Psychology,
} from '@mui/icons-material';
import { SxProps } from '@mui/material';

// ── SVGs customizados para nichos sem ícone no MUI ──────────────────────────

const LashIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      <path d="M2 18 Q12 22 22 18" stroke={col} strokeWidth="2" strokeLinecap="round"/>
      <path d="M4.5 17 Q4 12 5 8"   stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M7.5 18 Q7.5 13 8.5 9"  stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M11 18.5 Q11.5 13.5 12 10" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M14.5 18 Q15.5 13.5 16 10" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M18 17 Q19.5 13 20 9"  stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
};

const NailIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      {/* corpo da unha */}
      <path d="M7 22 L7 11 Q11 6 15 11 L15 22 Z" stroke={col} strokeWidth="1.8" strokeLinejoin="round"/>
      {/* pincel */}
      <line x1="15" y1="9" x2="20.5" y2="3.5" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      {/* cabeça do pincel */}
      <path d="M20 2 L22 4 L21 5 L19 3 Z" fill={col}/>
    </svg>
  );
};

const BrowIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      {/* sobrancelha */}
      <path d="M2 15 Q5 7 12 8 Q19 9 22 13" stroke={col} strokeWidth="3.5" strokeLinecap="round"/>
      {/* olho fechado */}
      <path d="M4 18 Q12 23 20 18" stroke={col} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
};

const RazorIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      {/* cabo */}
      <rect x="10" y="2" width="4" height="13" rx="2" stroke={col} strokeWidth="1.8"/>
      {/* lâmina */}
      <path d="M7 14 L17 14 L15 20 L9 20 Z" stroke={col} strokeWidth="1.8" strokeLinejoin="round"/>
      {/* fio */}
      <line x1="9" y1="17" x2="15" y2="17" stroke={col} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  );
};

const HairDryerIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      {/* corpo secador */}
      <path d="M3 8 Q3 4 7 4 L14 4 Q18 4 18 8 Q18 12 14 12 L7 12 Q3 12 3 8 Z" stroke={col} strokeWidth="1.8"/>
      {/* bico */}
      <path d="M18 7 L22 6 L22 10 L18 9 Z" stroke={col} strokeWidth="1.5" strokeLinejoin="round"/>
      {/* cabo */}
      <line x1="8" y1="12" x2="6" y2="20" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      {/* vento */}
      <path d="M20 3 Q22 5 20 7" stroke={col} strokeWidth="1.4" strokeLinecap="round" fill="none"/>
      <path d="M21 1 Q24 4 21 7" stroke={col} strokeWidth="1.2" strokeLinecap="round" fill="none"/>
    </svg>
  );
};

const BeardIcon = ({ sx = {} }: any) => {
  const sz = sx.fontSize || 24;
  const col = sx.color || 'currentColor';
  return (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0 }}>
      {/* rosto */}
      <circle cx="12" cy="9" r="5" stroke={col} strokeWidth="1.8"/>
      {/* barba */}
      <path d="M7 12 Q5 17 7 20 Q12 23 17 20 Q19 17 17 12" stroke={col} strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      {/* bigode */}
      <path d="M9 14 Q12 16 15 14" stroke={col} strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    </svg>
  );
};

// ── Mapa de ícones ───────────────────────────────────────────────────────────

export const BUSINESS_TYPE_ICONS: Record<string, { label: string; Icon: any; emoji: string }> = {
  // Negócios
  barbearia:    { label: 'Barbearia',      Icon: ContentCut,         emoji: '✂️' },
  barba:        { label: 'Barba',          Icon: BeardIcon,          emoji: '🧔' },
  navalha:      { label: 'Navalha',        Icon: RazorIcon,          emoji: '🪒' },
  salao:        { label: 'Salão',          Icon: HairDryerIcon,      emoji: '💇' },
  manicure:     { label: 'Manicure',       Icon: NailIcon,           emoji: '💅' },
  nail_designer: { label: 'Nail Designer',  Icon: NailIcon,           emoji: '💅' },
  cilios:       { label: 'Cílios',         Icon: LashIcon,           emoji: '👁️' },
  sobrancelhas: { label: 'Sobrancelha',    Icon: BrowIcon,           emoji: '🤨' },
  estetica:     { label: 'Estética',       Icon: Spa,                emoji: '✨' },
  clinica:      { label: 'Clínica',        Icon: HealthAndSafety,    emoji: '🏥' },
  tattoo:       { label: 'Tattoo',         Icon: ColorLens,          emoji: '🎨' },
  massagem:     { label: 'Massagem',       Icon: SelfImprovement,    emoji: '💆' },
  // Beleza & Corpo
  maquiagem:    { label: 'Maquiagem',      Icon: Palette,            emoji: '💄' },
  depilacao:    { label: 'Depilação',      Icon: Flare,              emoji: '⚡' },
  hidratacao:   { label: 'Hidratação',     Icon: WaterDrop,          emoji: '💧' },
  coloracao:    { label: 'Coloração',      Icon: InvertColors,       emoji: '🎨' },
  limpeza:      { label: 'Limpeza',        Icon: CleanHands,         emoji: '🧼' },
  piercing:     { label: 'Piercing',       Icon: RadioButtonChecked, emoji: '💎' },
  // Saúde & Bem-estar
  fitness:      { label: 'Fitness',        Icon: FitnessCenter,      emoji: '💪' },
  yoga:         { label: 'Yoga',           Icon: EmojiNature,        emoji: '🧘' },
  medicina:     { label: 'Medicina',       Icon: MedicalServices,    emoji: '🏥' },
  psicologia:   { label: 'Psicologia',     Icon: Psychology,         emoji: '🧠' },
  cura:         { label: 'Terapia',        Icon: Healing,            emoji: '💚' },
  // Estilo livre
  pet:          { label: 'Pet',            Icon: Pets,               emoji: '🐾' },
  kids:         { label: 'Kids',           Icon: ChildCare,          emoji: '👶' },
  joias:        { label: 'Joias',          Icon: Diamond,            emoji: '💎' },
  estrela:      { label: 'Estrela',        Icon: AutoAwesome,        emoji: '⭐' },
  coracao:      { label: 'Coração',        Icon: Favorite,           emoji: '❤️' },
  outros:       { label: 'Outros',         Icon: LocalFlorist,       emoji: '🌸' },
};

export const BUSINESS_TYPES = Object.entries(BUSINESS_TYPE_ICONS).map(([value, { label }]) => ({ value, label }));

interface ServiceIconProps {
  imageUrl?: string | null;
  businessType?: string | null;
  defaultServiceIcon?: string | null;
  size?: number;
  color?: string;
  sx?: SxProps;
}

export function ServiceIcon({ imageUrl, businessType, defaultServiceIcon, size = 22, color, sx }: ServiceIconProps) {
  const [err, setErr] = React.useState(false);

  const iconKey = defaultServiceIcon && defaultServiceIcon !== 'auto'
    ? defaultServiceIcon
    : (businessType || 'barbearia');

  const entry = BUSINESS_TYPE_ICONS[iconKey] || BUSINESS_TYPE_ICONS['barbearia'];
  const IconComp = entry.Icon;
  const iconColor = color || '#ccc';

  if (imageUrl && !err) {
    return (
      <img
        src={imageUrl}
        alt=""
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={() => setErr(true)}
      />
    );
  }

  return <IconComp sx={{ fontSize: size, color: iconColor, ...(sx || {}) }} />;
}

export default ServiceIcon;
